export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f9bd5e9af85e9a1864b542350ce8c8e3ed6f87f85&name=fetchTypeahead!'